/**
 * Amplify's "auth" Hub events, handed to the handler _app registers, without _app importing Amplify.
 *
 * Amplify (about 160 KB of the shell) used to be configured and listened to at start-up on every page,
 * although only sign-in, sign-out and the Hosted UI return use it. It is now loaded by those features
 * (src/lib/amplify.ts), and src/lib/amplify.ts forwards the events here. An event that arrives before
 * _app has registered its handler is kept and delivered on registration.
 */

/** What _app reads of a Hub capsule. */
export type AuthEvent = { payload: { event: string } };
type Handler = (event: AuthEvent) => void;

let handler: Handler | null = null;
const pending: AuthEvent[] = [];

export const dispatchAuthEvent = (event: AuthEvent) => {
    if (handler) handler(event);
    else pending.push(event);
};

/** Registers the handler for auth events and returns its removal. */
export const setAuthEventHandler = (next: Handler) => {
    handler = next;
    while (handler === next && pending.length) next(pending.shift() as AuthEvent);
    return () => {
        if (handler === next) handler = null;
    };
};
